module.exports = __webpack_public_path__ + "static/works-lodg-site-3abde9f14560d8f880b1a399ae114078.png";